module.exports = __webpack_public_path__ + "assets/img/zhou_text.fc054df3.png";